'use client';

import dynamic from 'next/dynamic';

const TelegramFloatingButton = dynamic(() => import('@/components/TelegramFloatingButton'), {
  ssr: false,
});

const SpeedInsights = dynamic(
  () => import('@vercel/speed-insights/next').then((module) => module.SpeedInsights),
  { ssr: false }
);

export default function ClientLayoutEnhancers() {
  return (
    <>
      <TelegramFloatingButton />
      <SpeedInsights />
    </>
  );
}